import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  FiHome as Home,
  FiCreditCard as CreditCard,
  FiPhone as Phone,
  FiDollarSign as DollarSign,
  FiMoreHorizontal as MoreHorizontal
} from 'react-icons/fi';

/**
 * Phone-only bottom navigation. These four destinations are what someone
 * actually needs while standing at the roadside — everything else lives
 * behind "More".
 */
const tabs = [
  { path: '/dashboard', icon: Home, label: 'Home', exact: true },
  { path: '/dashboard/id-cards', icon: CreditCard, label: 'ID Cards' },
  { path: '/dashboard/claims', icon: Phone, label: 'Claim' },
  { path: '/dashboard/payment', icon: DollarSign, label: 'Pay' }
];

const MobileTabBar = ({ onMoreClick }) => (
  <nav
    aria-label="Primary"
    className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-gray-200 shadow-[0_-1px_8px_rgba(0,0,0,0.06)] pb-[env(safe-area-inset-bottom)]"
  >
    <div className="grid grid-cols-5">
      {tabs.map((tab) => (
        <NavLink
          key={tab.path}
          to={tab.path}
          end={tab.exact}
          className={({ isActive }) =>
            `flex flex-col items-center justify-center gap-1 py-2.5 min-h-[56px] transition-colors ${
              isActive ? 'text-[#DC143C]' : 'text-gray-500'
            }`
          }
        >
          <tab.icon size={22} />
          <span className="text-[11px] font-medium leading-none">{tab.label}</span>
        </NavLink>
      ))}
      <button
        onClick={onMoreClick}
        aria-label="Open menu"
        className="flex flex-col items-center justify-center gap-1 py-2.5 min-h-[56px] text-gray-500 hover:text-[#DC143C] transition-colors"
      >
        <MoreHorizontal size={22} />
        <span className="text-[11px] font-medium leading-none">More</span>
      </button>
    </div>
  </nav>
);

export default MobileTabBar;
